import { Store } from 'store/index';
import getCart from './getCart';

const getCartNumberOfItems = (store: Store) => {
  const carts = getCart(store);
  return carts.reduce((sum, cart) => {
    return sum + (cart?.items?.length || 0);
  }, 0);
};

export default getCartNumberOfItems;
